import type { SxProps, Theme } from '@mui/material';

export const menuPaperSx: SxProps<Theme> = {
  maxHeight: 200,
  maxWidth: '286px',
};

export const menuItemContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const chipSx: SxProps<Theme> = {
  fontSize: '0.7rem',
  height: 20,
};

export const menuItemTextSx: SxProps<Theme> = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  width: '210px',
};
